import type { FaireProductEntity } from "../../entity_types/product";

export const p_5h5ywaxuye: FaireProductEntity = {
  token: "p_5h5ywaxuye",
  type: "product",
  name: "Arkansas® Hogs Bobble Hat (Baby, Toddler, Kid)",
  brandToken: "b_878xd92w4w",
  brandName: "Bits & Bows",
  imageUrl:
    "https://cdn.faire.com/fastly/19d3cf6d0c7203327691967a255519ce04f46af9f1475a9d2484044aa9497a79.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6b2c0f73583b5f983d6bb8d339232fe6e9602b3815ac82bb631263d751655b38.jpeg",
  ],
  priceDollars: 19.5,
  description:
    "Cheer on the Arkansas® Razorbacks with this officially licensed Game Day Bobble Hat from Bits & Bows. These comfy, cozy, and cute giftable accessories combine playful polish, functionality, and fun in one sweet sportswear style made just for the littlest fans!\n\n• Sizing details: Baby (3-12 months), Toddler (12-36 months), Kid (3-7 years)\n• Crafted of soft and snuggly 100% acrylic yarn\n• Bobble Hats feature an oversized pom and fold-over brim\n",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:59.547Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
